import axios, { AxiosResponse } from 'axios';
import { IContactInfo } from '../model/contact.model';

export interface IContactApi {
  createContact(contact: IContactInfo): Promise<AxiosResponse<any>>;
}

export class ContactApi implements IContactApi {
  async createContact(contact: IContactInfo): Promise<AxiosResponse<any>> {
    return axios.put('api/contact/createContact', contact);
  }
  async toClientIpContactModel(contact: IContactInfo): Promise<AxiosResponse<any>> {
    return axios.put('api/contact/toClientIpContactModel', contact);
  }
}

